module.exports = __webpack_public_path__ + "./images/3.420b40a19770a0fba8c58014d3d8268b.png";